// components/Footer.tsx
import instagram from "@assets/instagram.svg";
import linkedin from "@assets/linkedin.svg";
import globe from "@assets/globe.svg";
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#16263B] text-white py-6 w-full px-5 md:px-24">
      <div className="mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        {/* Social Icons */}
        <div className="flex space-x-4">
          <a
            href="https://www.linkedin.com/company/thearkcompany"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} className="w-6 h-6" />
          </a>
          <a
            href="https://www.instagram.com/thearknetwork/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} className="w-6 h-6" />
          </a>
        </div>

        {/* Center Text */}
        <div className="text-center text-sm">
          <p className="flex items-center">
            © {year} Made for <img src={globe} className="w-6 h-6 ml-2" /> by
            THE ARK
          </p>
        </div>

        {/* Links */}
        <div className="text-center md:text-right text-sm space-y-1">
          <a
            href="/privacy"
            className="block hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="/terms"
            className="block hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
